<template>
  <vue-slider
    v-bind="$attrs"
    v-on="$listeners"
    :value="value"
    @change="e => inputChanged(e)"
  ></vue-slider>
</template>

<script>
export default {
  name: 'HMSlider',
  props: {
    value: {
      type: Array,
    },
  },
  methods: {
    inputChanged(e) {
      this.$emit('input', e);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';

::v-deep .slider {
  background-color: $medium-gray !important;
}
::v-deep .vue-slider-process {
  background-color: var(--brand-color, $coral) !important;
}
::v-deep .vue-slider-dot-tooltip-inner {
  background-color: $charcoal !important;
  border-color: $charcoal !important;
}
::v-deep .vue-slider-dot-tooltip-text {
  background-color: $charcoal !important;
  border-color: $charcoal !important;
}
</style>
